// ------------------------------------
// Constants
// ------------------------------------
// prettier-ignore
export const NETWORK_HA_TUNNELS_DELETE_REQUEST = 'NETWORK_HA_TUNNELS_DELETE_REQUEST';
// prettier-ignore
export const NETWORK_HA_TUNNELS_DELETE_REQUEST_SUCCESS = 'NETWORK_HA_TUNNELS_DELETE_REQUEST_SUCCESS';
// prettier-ignore
export const NETWORK_HA_TUNNELS_DELETE_REQUEST_FAILURE = 'NETWORK_HA_TUNNELS_DELETE_REQUEST_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: NETWORK_HA_TUNNELS_DELETE_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(data, payload) {
  return {
    type: NETWORK_HA_TUNNELS_DELETE_REQUEST_SUCCESS,
    data,
    payload,
  };
}

export function requestFailure(error, payload) {
  return {
    type: NETWORK_HA_TUNNELS_DELETE_REQUEST_FAILURE,
    error,
    payload,
  };
}
